import React, { Component } from 'react'
import Header from '../components/Header'
import Card1 from '../components/cards/Card1'
import { connect } from 'react-redux';
import { changeStateValue } from '../redux/MainReducer';
import { getActivities} from '../actions/MainAction';
export class ActivitiesPage extends Component {
  
  openModal=(data, lang, lang_id=1)=>{
    this.props.changeStateValue({
      name:"mainModal",
      value:{
        position:true,
        id: data?.id?data?.id:"",
        image: data?.image?data?.image:"",
        image_full_url: data?.image_full_url?data?.image_full_url:"",
        icon: data?.icon?data?.icon:"",
        icon_full_url: data?.icon_full_url?data?.icon_full_url:"",
        languages:
          {
            id:lang?.id?lang?.id:'',
            title:lang?.title?lang?.title:'',
            text:lang?.text?lang?.text:'',
            sub_title:lang?.sub_title?lang?.sub_title:'',
            lang_id:lang_id
          }
        ,
        requiredsLang: ["title"],
        requireds:[],
        afterCallFunction:this.props.getActivities,
        afterParams:[],
        url:'admin-activities'
      }
    })
  }

  componentDidMount(){
    this.props.getActivities();
  }
  render() {
    const {adminActivities} = this.props;
    console.log(adminActivities)
    return (
      <div className='p-[40px] w-full'>
        <Header onClickBtn={this.openModal.bind(this, "", "", 1)} title="Activities" />
        <div className='grid-full-250 grid grid-cols-2 mt-[20px]'>
          {
            adminActivities?.map((data, i)=>{
              return(
                <Card1 
                  key={i}
                  image={data?.image_full_url}
                  video={data?.video_full_url}
                  onChangeLang={(id)=>this.openModal(data, data.translates.find(x=>x.lang_id==id), id)} 
                  title1={data?.translate?.title}
                  deleteUrl={`admin-activities/${data?.id}`}
                  afterCallFunction={()=> this.props.getActivities()}
                />
              )
            })
          }
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state)=>({
  adminActivities: state.Data.adminActivities,
});
const mapDispatchToProps = {changeStateValue, getActivities}
export default connect(mapStateToProps, mapDispatchToProps)(ActivitiesPage)
 
